module.exports = __webpack_public_path__ + "static/media/galerija_2022_0058.6b9375c7.jpg";